import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useRtl as Qt } from "../../_mixins/use-rtl.js";
import { isSafari as Zt } from "../../_utils/env/browser.js";
import { inputInjectionKey as en } from "./interface.js";
import tn, { safariStyle as nn } from "./styles/input.cssr.js";
import { useCursor as on, isEmptyInputValue as L } from "./utils.js";
import ue from "./WordCount.js";
import rn from "../../_mixins/use-config.js";
import be from "../../_mixins/use-theme.js";
import ln from "../../_mixins/use-style.js";
import an from "../../_mixins/use-locale.js";
import sn from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import un from "../../_mixins/use-form-item.js";
import de from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import { createKey as ne } from "../../_utils/cssr/index.js";
import { getMargin as dn } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import { useThemeClass as cn } from "../../_mixins/use-css-vars-class.js";
import { resolveWrappedSlot as j, resolveSlot as oe } from "../../_utils/vue/resolve-slot.js";
import fn from "../../_internal/scrollbar/src/Scrollbar.js";
import hn from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/resize-observer/src/VResizeObserver.js";
import vn from "../styles/light.js";
import { on as ce, off as fe } from "../../../../../../evtd@0.2.4/node_modules/evtd/es/delegate.js";
import { call as p } from "../../_utils/vue/call.js";
import he from "../../_internal/clear/src/Clear.js";
import pn from "../../_internal/suffix/src/Suffix.js";
import ve from "../../_internal/icon/src/Icon.js";
import gn from "../../_internal/icons/Eye.js";
import mn from "../../_internal/icons/EyeOff.js";
import { defineComponent as yn, computed as C, onMounted as bn, getCurrentInstance as xn, watchEffect as pe, provide as wn, h as l, Fragment as Cn, nextTick as ge, watch as me } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as g, toRef as ye } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const Sn = Object.assign(Object.assign({}, be.props), {
  bordered: {
    type: Boolean,
    default: void 0
  },
  type: {
    type: String,
    default: "text"
  },
  placeholder: [Array, String],
  defaultValue: {
    type: [String, Array],
    default: null
  },
  value: [String, Array],
  disabled: {
    type: Boolean,
    default: void 0
  },
  size: String,
  rows: {
    type: [Number, String],
    default: 3
  },
  round: Boolean,
  minlength: [String, Number],
  maxlength: [String, Number],
  clearable: Boolean,
  autosize: {
    type: [Boolean, Object],
    default: !1
  },
  pair: Boolean,
  separator: String,
  readonly: {
    type: [String, Boolean],
    default: !1
  },
  passivelyActivated: Boolean,
  showPasswordOn: String,
  stateful: {
    type: Boolean,
    default: !0
  },
  autofocus: Boolean,
  inputProps: Object,
  resizable: {
    type: Boolean,
    default: !0
  },
  showCount: Boolean,
  loading: {
    type: Boolean,
    default: void 0
  },
  allowInput: Function,
  renderCount: Function,
  onMousedown: Function,
  onKeydown: Function,
  onKeyup: [Function, Array],
  onInput: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onClick: [Function, Array],
  onChange: [Function, Array],
  onClear: [Function, Array],
  countGraphemes: Function,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  /** private */
  textDecoration: [String, Array],
  attrSize: {
    type: Number,
    default: 20
  },
  onInputBlur: [Function, Array],
  onInputFocus: [Function, Array],
  onDeactivate: [Function, Array],
  onActivate: [Function, Array],
  onWrapperFocus: [Function, Array],
  onWrapperBlur: [Function, Array],
  internalDeactivateOnEnter: Boolean,
  internalForceFocus: Boolean,
  internalLoadingBeforeSuffix: {
    type: Boolean,
    default: !0
  },
  /** deprecated */
  showPasswordToggle: Boolean
}), eo = yn({
  name: "Input",
  props: Sn,
  slots: Object,
  setup(n) {
    const {
      mergedClsPrefixRef: y,
      mergedBorderedRef: r,
      inlineThemeDisabled: P,
      mergedRtlRef: G
    } = rn(n), b = be("Input", "-input", tn, vn, n, y);
    Zt && ln("-input-safari", nn, y);
    const v = g(null), f = g(null), c = g(null), i = g(null), a = g(null), h = g(null), m = g(null), D = on(m), S = g(null), {
      localeRef: xe
    } = an("Input"), W = g(n.defaultValue), we = ye(n, "value"), x = sn(we, W), I = un(n), {
      mergedSizeRef: X,
      mergedDisabledRef: _,
      mergedStatusRef: Ce
    } = I, B = g(!1), T = g(!1), w = g(!1), $ = g(!1);
    let Y = null;
    const q = C(() => {
      const {
        placeholder: e,
        pair: t
      } = n;
      return t ? Array.isArray(e) ? e : e === void 0 ? ["", ""] : [e, e] : e === void 0 ? [xe.value.placeholder] : [e];
    }), Se = C(() => {
      const {
        value: e
      } = w, {
        value: t
      } = x, {
        value: o
      } = q;
      return !e && (L(t) || Array.isArray(t) && L(t[0])) && o[0];
    }), Ae = C(() => {
      const {
        value: e
      } = w, {
        value: t
      } = x, {
        value: o
      } = q;
      return !e && o[1] && (L(t) || Array.isArray(t) && L(t[1]));
    }), J = de(() => n.internalForceFocus || B.value), Fe = de(() => {
      if (_.value || n.readonly || !n.clearable || !J.value && !T.value)
        return !1;
      const {
        value: e
      } = x, {
        value: t
      } = J;
      return n.pair ? !!(Array.isArray(e) && (e[0] || e[1])) && (T.value || t) : !!e && (T.value || t);
    }), Q = C(() => {
      const {
        showPasswordOn: e
      } = n;
      if (e)
        return e;
      if (n.showPasswordToggle)
        return "click";
    }), V = g(!1), Re = C(() => {
      const {
        textDecoration: e
      } = n;
      return e ? Array.isArray(e) ? e.map((t) => ({
        textDecoration: t
      })) : [{
        textDecoration: e
      }] : ["", ""];
    }), re = g(void 0), _e = () => {
      var e, t;
      if (n.type === "textarea") {
        const {
          autosize: o
        } = n;
        if (o && (re.value = (t = (e = S.value) === null || e === void 0 ? void 0 : e.$el) === null || t === void 0 ? void 0 : t.offsetWidth), !f.value || typeof o == "boolean")
          return;
        const {
          paddingTop: u,
          paddingBottom: d,
          lineHeight: s
        } = window.getComputedStyle(f.value), A = Number(u.slice(0, -2)), F = Number(d.slice(0, -2)), R = Number(s.slice(0, -2)), {
          value: z
        } = c;
        if (!z)
          return;
        if (o.minRows) {
          const M = Math.max(o.minRows, 1), te = `${A + F + R * M}px`;
          z.style.minHeight = te;
        }
        if (o.maxRows) {
          const M = `${A + F + R * o.maxRows}px`;
          z.style.maxHeight = M;
        }
      }
    }, Be = C(() => {
      const {
        maxlength: e
      } = n;
      return e === void 0 ? void 0 : Number(e);
    });
    bn(() => {
      const {
        value: e
      } = x;
      Array.isArray(e) || ee(e);
    });
    const Ee = xn().proxy;
    function O(e, t) {
      const {
        onUpdateValue: o,
        "onUpdate:value": u,
        onInput: d
      } = n, {
        nTriggerFormInput: s
      } = I;
      o && p(o, e, t), u && p(u, e, t), d && p(d, e, t), W.value = e, s();
    }
    function k(e, t) {
      const {
        onChange: o
      } = n, {
        nTriggerFormChange: u
      } = I;
      o && p(o, e, t), W.value = e, u();
    }
    function Pe(e) {
      const {
        onBlur: t
      } = n, {
        nTriggerFormBlur: o
      } = I;
      t && p(t, e), o();
    }
    function Ie(e) {
      const {
        onFocus: t
      } = n, {
        nTriggerFormFocus: o
      } = I;
      t && p(t, e), o();
    }
    function Te(e) {
      const {
        onClear: t
      } = n;
      t && p(t, e);
    }
    function $e(e) {
      const {
        onInputBlur: t
      } = n;
      t && p(t, e);
    }
    function Ve(e) {
      const {
        onInputFocus: t
      } = n;
      t && p(t, e);
    }
    function ze() {
      const {
        onDeactivate: e
      } = n;
      e && p(e);
    }
    function Me() {
      const {
        onActivate: e
      } = n;
      e && p(e);
    }
    function De(e) {
      const {
        onClick: t
      } = n;
      t && p(t, e);
    }
    function We(e) {
      const {
        onWrapperFocus: t
      } = n;
      t && p(t, e);
    }
    function Oe(e) {
      const {
        onWrapperBlur: t
      } = n;
      t && p(t, e);
    }
    function ke() {
      w.value = !0;
    }
    function Ne(e) {
      w.value = !1, e.target === h.value ? N(e, 1) : N(e, 0);
    }
    function N(e, t = 0, o = "input") {
      const u = e.target.value;
      if (ee(u), e instanceof InputEvent && !e.isComposing && (w.value = !1), n.type === "textarea") {
        const {
          value: s
        } = S;
        s && s.syncUnifiedContainer();
      }
      if (Y = u, w.value)
        return;
      D.recordCursor();
      const d = He(u);
      if (d)
        if (!n.pair)
          o === "input" ? O(u, {
            source: t
          }) : k(u, {
            source: t
          });
        else {
          let {
            value: s
          } = x;
          Array.isArray(s) ? s = [s[0], s[1]] : s = ["", ""], s[t] = u, o === "input" ? O(s, {
            source: t
          }) : k(s, {
            source: t
          });
        }
      Ee.$forceUpdate(), d || ge(D.restoreCursor);
    }
    function He(e) {
      const {
        countGraphemes: t,
        maxlength: o,
        minlength: u
      } = n;
      if (t) {
        let s;
        if (o !== void 0 && (s === void 0 && (s = t(e)), s > Number(o)) || u !== void 0 && (s === void 0 && (s = t(e)), s < Number(o)))
          return !1;
      }
      const {
        allowInput: d
      } = n;
      return typeof d == "function" ? d(e) : !0;
    }
    function Ke(e) {
      $e(e), e.relatedTarget === v.value && ze(), e.relatedTarget !== null && (e.relatedTarget === a.value || e.relatedTarget === h.value || e.relatedTarget === f.value) || ($.value = !1), H(e, "blur"), m.value = null;
    }
    function Ue(e, t) {
      Ve(e), B.value = !0, $.value = !0, Me(), H(e, "focus"), t === 0 ? m.value = a.value : t === 1 ? m.value = h.value : t === 2 && (m.value = f.value);
    }
    function Le(e) {
      n.passivelyActivated && (Oe(e), H(e, "blur"));
    }
    function je(e) {
      n.passivelyActivated && (B.value = !0, We(e), H(e, "focus"));
    }
    function H(e, t) {
      e.relatedTarget !== null && (e.relatedTarget === a.value || e.relatedTarget === h.value || e.relatedTarget === f.value || e.relatedTarget === v.value) || (t === "focus" ? (Ie(e), B.value = !0) : t === "blur" && (Pe(e), B.value = !1));
    }
    function Ge(e, t) {
      N(e, t, "change");
    }
    function Xe(e) {
      De(e);
    }
    function Ye(e) {
      Te(e), le();
    }
    function le() {
      n.pair ? (O(["", ""], {
        source: "clear"
      }), k(["", ""], {
        source: "clear"
      })) : (O("", {
        source: "clear"
      }), k("", {
        source: "clear"
      }));
    }
    function qe(e) {
      const {
        onMousedown: t
      } = n;
      t && t(e);
      const {
        tagName: o
      } = e.target;
      if (o !== "INPUT" && o !== "TEXTAREA") {
        if (n.resizable) {
          const {
            value: u
          } = v;
          if (u) {
            const {
              left: d,
              top: s,
              width: A,
              height: F
            } = u.getBoundingClientRect(), R = 14;
            if (d + A - R < e.clientX && e.clientX < d + A && s + F - R < e.clientY && e.clientY < s + F)
              return;
          }
        }
        e.preventDefault(), B.value || ae();
      }
    }
    function Je() {
      var e;
      T.value = !0, n.type === "textarea" && ((e = S.value) === null || e === void 0 || e.handleMouseEnterWrapper());
    }
    function Qe() {
      var e;
      T.value = !1, n.type === "textarea" && ((e = S.value) === null || e === void 0 || e.handleMouseLeaveWrapper());
    }
    function Ze() {
      _.value || Q.value === "click" && (V.value = !V.value);
    }
    function et(e) {
      if (_.value)
        return;
      e.preventDefault();
      const t = (u) => {
        u.preventDefault(), fe("mouseup", document, t);
      };
      if (ce("mouseup", document, t), Q.value !== "mousedown")
        return;
      V.value = !0;
      const o = () => {
        V.value = !1, fe("mouseup", document, o);
      };
      ce("mouseup", document, o);
    }
    function tt(e) {
      n.onKeyup && p(n.onKeyup, e);
    }
    function nt(e) {
      switch (n.onKeydown && p(n.onKeydown, e), e.key) {
        case "Escape":
          Z();
          break;
        case "Enter":
          ot(e);
          break;
      }
    }
    function ot(e) {
      var t, o;
      if (n.passivelyActivated) {
        const {
          value: u
        } = $;
        if (u) {
          n.internalDeactivateOnEnter && Z();
          return;
        }
        e.preventDefault(), n.type === "textarea" ? (t = f.value) === null || t === void 0 || t.focus() : (o = a.value) === null || o === void 0 || o.focus();
      }
    }
    function Z() {
      n.passivelyActivated && ($.value = !1, ge(() => {
        var e;
        (e = v.value) === null || e === void 0 || e.focus();
      }));
    }
    function ae() {
      var e, t, o;
      _.value || (n.passivelyActivated ? (e = v.value) === null || e === void 0 || e.focus() : ((t = f.value) === null || t === void 0 || t.focus(), (o = a.value) === null || o === void 0 || o.focus()));
    }
    function rt() {
      var e;
      !((e = v.value) === null || e === void 0) && e.contains(document.activeElement) && document.activeElement.blur();
    }
    function lt() {
      var e, t;
      (e = f.value) === null || e === void 0 || e.select(), (t = a.value) === null || t === void 0 || t.select();
    }
    function at() {
      _.value || (f.value ? f.value.focus() : a.value && a.value.focus());
    }
    function it() {
      const {
        value: e
      } = v;
      e != null && e.contains(document.activeElement) && e !== document.activeElement && Z();
    }
    function st(e) {
      if (n.type === "textarea") {
        const {
          value: t
        } = f;
        t == null || t.scrollTo(e);
      } else {
        const {
          value: t
        } = a;
        t == null || t.scrollTo(e);
      }
    }
    function ee(e) {
      const {
        type: t,
        pair: o,
        autosize: u
      } = n;
      if (!o && u)
        if (t === "textarea") {
          const {
            value: d
          } = c;
          d && (d.textContent = `${e != null ? e : ""}\r
`);
        } else {
          const {
            value: d
          } = i;
          d && (e ? d.textContent = e : d.innerHTML = "&nbsp;");
        }
    }
    function ut() {
      _e();
    }
    const ie = g({
      top: "0"
    });
    function dt(e) {
      var t;
      const {
        scrollTop: o
      } = e.target;
      ie.value.top = `${-o}px`, (t = S.value) === null || t === void 0 || t.syncUnifiedContainer();
    }
    let K = null;
    pe(() => {
      const {
        autosize: e,
        type: t
      } = n;
      e && t === "textarea" ? K = me(x, (o) => {
        !Array.isArray(o) && o !== Y && ee(o);
      }) : K == null || K();
    });
    let U = null;
    pe(() => {
      n.type === "textarea" ? U = me(x, (e) => {
        var t;
        !Array.isArray(e) && e !== Y && ((t = S.value) === null || t === void 0 || t.syncUnifiedContainer());
      }) : U == null || U();
    }), wn(en, {
      mergedValueRef: x,
      maxlengthRef: Be,
      mergedClsPrefixRef: y,
      countGraphemesRef: ye(n, "countGraphemes")
    });
    const ct = {
      wrapperElRef: v,
      inputElRef: a,
      textareaElRef: f,
      isCompositing: w,
      clear: le,
      focus: ae,
      blur: rt,
      select: lt,
      deactivate: it,
      activate: at,
      scrollTo: st
    }, ft = Qt("Input", G, y), se = C(() => {
      const {
        value: e
      } = X, {
        common: {
          cubicBezierEaseInOut: t
        },
        self: {
          color: o,
          borderRadius: u,
          textColor: d,
          caretColor: s,
          caretColorError: A,
          caretColorWarning: F,
          textDecorationColor: R,
          border: z,
          borderDisabled: M,
          borderHover: te,
          borderFocus: ht,
          placeholderColor: vt,
          placeholderColorDisabled: pt,
          lineHeightTextarea: gt,
          colorDisabled: mt,
          colorFocus: yt,
          textColorDisabled: bt,
          boxShadowFocus: xt,
          iconSize: wt,
          colorFocusWarning: Ct,
          boxShadowFocusWarning: St,
          borderWarning: At,
          borderFocusWarning: Ft,
          borderHoverWarning: Rt,
          colorFocusError: _t,
          boxShadowFocusError: Bt,
          borderError: Et,
          borderFocusError: Pt,
          borderHoverError: It,
          clearSize: Tt,
          clearColor: $t,
          clearColorHover: Vt,
          clearColorPressed: zt,
          iconColor: Mt,
          iconColorDisabled: Dt,
          suffixTextColor: Wt,
          countTextColor: Ot,
          countTextColorDisabled: kt,
          iconColorHover: Nt,
          iconColorPressed: Ht,
          loadingColor: Kt,
          loadingColorError: Ut,
          loadingColorWarning: Lt,
          fontWeight: jt,
          [ne("padding", e)]: Gt,
          [ne("fontSize", e)]: Xt,
          [ne("height", e)]: Yt
        }
      } = b.value, {
        left: qt,
        right: Jt
      } = dn(Gt);
      return {
        "--n-bezier": t,
        "--n-count-text-color": Ot,
        "--n-count-text-color-disabled": kt,
        "--n-color": o,
        "--n-font-size": Xt,
        "--n-font-weight": jt,
        "--n-border-radius": u,
        "--n-height": Yt,
        "--n-padding-left": qt,
        "--n-padding-right": Jt,
        "--n-text-color": d,
        "--n-caret-color": s,
        "--n-text-decoration-color": R,
        "--n-border": z,
        "--n-border-disabled": M,
        "--n-border-hover": te,
        "--n-border-focus": ht,
        "--n-placeholder-color": vt,
        "--n-placeholder-color-disabled": pt,
        "--n-icon-size": wt,
        "--n-line-height-textarea": gt,
        "--n-color-disabled": mt,
        "--n-color-focus": yt,
        "--n-text-color-disabled": bt,
        "--n-box-shadow-focus": xt,
        "--n-loading-color": Kt,
        // form warning
        "--n-caret-color-warning": F,
        "--n-color-focus-warning": Ct,
        "--n-box-shadow-focus-warning": St,
        "--n-border-warning": At,
        "--n-border-focus-warning": Ft,
        "--n-border-hover-warning": Rt,
        "--n-loading-color-warning": Lt,
        // form error
        "--n-caret-color-error": A,
        "--n-color-focus-error": _t,
        "--n-box-shadow-focus-error": Bt,
        "--n-border-error": Et,
        "--n-border-focus-error": Pt,
        "--n-border-hover-error": It,
        "--n-loading-color-error": Ut,
        // clear-button
        "--n-clear-color": $t,
        "--n-clear-size": Tt,
        "--n-clear-color-hover": Vt,
        "--n-clear-color-pressed": zt,
        "--n-icon-color": Mt,
        "--n-icon-color-hover": Nt,
        "--n-icon-color-pressed": Ht,
        "--n-icon-color-disabled": Dt,
        "--n-suffix-text-color": Wt
      };
    }), E = P ? cn("input", C(() => {
      const {
        value: e
      } = X;
      return e[0];
    }), se, n) : void 0;
    return Object.assign(Object.assign({}, ct), {
      // DOM ref
      wrapperElRef: v,
      inputElRef: a,
      inputMirrorElRef: i,
      inputEl2Ref: h,
      textareaElRef: f,
      textareaMirrorElRef: c,
      textareaScrollbarInstRef: S,
      // value
      rtlEnabled: ft,
      uncontrolledValue: W,
      mergedValue: x,
      passwordVisible: V,
      mergedPlaceholder: q,
      showPlaceholder1: Se,
      showPlaceholder2: Ae,
      mergedFocus: J,
      isComposing: w,
      activated: $,
      showClearButton: Fe,
      mergedSize: X,
      mergedDisabled: _,
      textDecorationStyle: Re,
      mergedClsPrefix: y,
      mergedBordered: r,
      mergedShowPasswordOn: Q,
      placeholderStyle: ie,
      mergedStatus: Ce,
      textAreaScrollContainerWidth: re,
      // methods
      handleTextAreaScroll: dt,
      handleCompositionStart: ke,
      handleCompositionEnd: Ne,
      handleInput: N,
      handleInputBlur: Ke,
      handleInputFocus: Ue,
      handleWrapperBlur: Le,
      handleWrapperFocus: je,
      handleMouseEnter: Je,
      handleMouseLeave: Qe,
      handleMouseDown: qe,
      handleChange: Ge,
      handleClick: Xe,
      handleClear: Ye,
      handlePasswordToggleClick: Ze,
      handlePasswordToggleMousedown: et,
      handleWrapperKeydown: nt,
      handleWrapperKeyup: tt,
      handleTextAreaMirrorResize: ut,
      getTextareaScrollContainer: () => f.value,
      mergedTheme: b,
      cssVars: P ? void 0 : se,
      themeClass: E == null ? void 0 : E.themeClass,
      onRender: E == null ? void 0 : E.onRender
    });
  },
  render() {
    var n, y;
    const {
      mergedClsPrefix: r,
      mergedStatus: P,
      themeClass: G,
      type: b,
      countGraphemes: v,
      onRender: f
    } = this, c = this.$slots;
    return f == null || f(), l("div", {
      ref: "wrapperElRef",
      class: [`${r}-input`, G, P && `${r}-input--${P}-status`, {
        [`${r}-input--rtl`]: this.rtlEnabled,
        [`${r}-input--disabled`]: this.mergedDisabled,
        [`${r}-input--textarea`]: b === "textarea",
        [`${r}-input--resizable`]: this.resizable && !this.autosize,
        [`${r}-input--autosize`]: this.autosize,
        [`${r}-input--round`]: this.round && b !== "textarea",
        [`${r}-input--pair`]: this.pair,
        [`${r}-input--focus`]: this.mergedFocus,
        [`${r}-input--stateful`]: this.stateful
      }],
      style: this.cssVars,
      tabindex: !this.mergedDisabled && this.passivelyActivated && !this.activated ? 0 : void 0,
      onFocus: this.handleWrapperFocus,
      onBlur: this.handleWrapperBlur,
      onClick: this.handleClick,
      onMousedown: this.handleMouseDown,
      onMouseenter: this.handleMouseEnter,
      onMouseleave: this.handleMouseLeave,
      onCompositionstart: this.handleCompositionStart,
      onCompositionend: this.handleCompositionEnd,
      onKeyup: this.handleWrapperKeyup,
      onKeydown: this.handleWrapperKeydown
    }, l("div", {
      class: `${r}-input-wrapper`
    }, j(c.prefix, (i) => i && l("div", {
      class: `${r}-input__prefix`
    }, i)), b === "textarea" ? l(fn, {
      ref: "textareaScrollbarInstRef",
      class: `${r}-input__textarea`,
      container: this.getTextareaScrollContainer,
      triggerDisplayManually: !0,
      useUnifiedContainer: !0,
      internalHoistYRail: !0
    }, {
      default: () => {
        var i, a;
        const {
          textAreaScrollContainerWidth: h
        } = this, m = {
          width: this.autosize && h && `${h}px`
        };
        return l(Cn, null, l("textarea", Object.assign({}, this.inputProps, {
          ref: "textareaElRef",
          class: [`${r}-input__textarea-el`, (i = this.inputProps) === null || i === void 0 ? void 0 : i.class],
          autofocus: this.autofocus,
          rows: Number(this.rows),
          placeholder: this.placeholder,
          value: this.mergedValue,
          disabled: this.mergedDisabled,
          maxlength: v ? void 0 : this.maxlength,
          minlength: v ? void 0 : this.minlength,
          readonly: this.readonly,
          tabindex: this.passivelyActivated && !this.activated ? -1 : void 0,
          style: [this.textDecorationStyle[0], (a = this.inputProps) === null || a === void 0 ? void 0 : a.style, m],
          onBlur: this.handleInputBlur,
          onFocus: (D) => {
            this.handleInputFocus(D, 2);
          },
          onInput: this.handleInput,
          onChange: this.handleChange,
          onScroll: this.handleTextAreaScroll
        })), this.showPlaceholder1 ? l("div", {
          class: `${r}-input__placeholder`,
          style: [this.placeholderStyle, m],
          key: "placeholder"
        }, this.mergedPlaceholder[0]) : null, this.autosize ? l(hn, {
          onResize: this.handleTextAreaMirrorResize
        }, {
          default: () => l("div", {
            ref: "textareaMirrorElRef",
            class: `${r}-input__textarea-mirror`,
            key: "mirror"
          })
        }) : null);
      }
    }) : l("div", {
      class: `${r}-input__input`
    }, l("input", Object.assign({
      type: b === "password" && this.mergedShowPasswordOn && this.passwordVisible ? "text" : b
    }, this.inputProps, {
      ref: "inputElRef",
      class: [`${r}-input__input-el`, (n = this.inputProps) === null || n === void 0 ? void 0 : n.class],
      style: [this.textDecorationStyle[0], (y = this.inputProps) === null || y === void 0 ? void 0 : y.style],
      tabindex: this.passivelyActivated && !this.activated ? -1 : void 0,
      placeholder: this.mergedPlaceholder[0],
      disabled: this.mergedDisabled,
      maxlength: v ? void 0 : this.maxlength,
      minlength: v ? void 0 : this.minlength,
      value: Array.isArray(this.mergedValue) ? this.mergedValue[0] : this.mergedValue,
      readonly: this.readonly,
      autofocus: this.autofocus,
      size: this.attrSize,
      onBlur: this.handleInputBlur,
      onFocus: (i) => {
        this.handleInputFocus(i, 0);
      },
      onInput: (i) => {
        this.handleInput(i, 0);
      },
      onChange: (i) => {
        this.handleChange(i, 0);
      }
    })), this.showPlaceholder1 ? l("div", {
      class: `${r}-input__placeholder`
    }, l("span", null, this.mergedPlaceholder[0])) : null, this.autosize ? l("div", {
      class: `${r}-input__input-mirror`,
      key: "mirror",
      ref: "inputMirrorElRef"
    }, " ") : null), !this.pair && j(c.suffix, (i) => i || this.clearable || this.showCount || this.mergedShowPasswordOn || this.loading !== void 0 ? l("div", {
      class: `${r}-input__suffix`
    }, [j(c["clear-icon-placeholder"], (a) => (this.clearable || a) && l(he, {
      clsPrefix: r,
      show: this.showClearButton,
      onClear: this.handleClear
    }, {
      placeholder: () => a,
      icon: () => {
        var h, m;
        return (m = (h = this.$slots)["clear-icon"]) === null || m === void 0 ? void 0 : m.call(h);
      }
    })), this.internalLoadingBeforeSuffix ? null : i, this.loading !== void 0 ? l(pn, {
      clsPrefix: r,
      loading: this.loading,
      showArrow: !1,
      showClear: !1,
      style: this.cssVars
    }) : null, this.internalLoadingBeforeSuffix ? i : null, this.showCount && this.type !== "textarea" ? l(ue, null, {
      default: (a) => {
        var h;
        const {
          renderCount: m
        } = this;
        return m ? m(a) : (h = c.count) === null || h === void 0 ? void 0 : h.call(c, a);
      }
    }) : null, this.mergedShowPasswordOn && this.type === "password" ? l("div", {
      class: `${r}-input__eye`,
      onMousedown: this.handlePasswordToggleMousedown,
      onClick: this.handlePasswordToggleClick
    }, this.passwordVisible ? oe(c["password-visible-icon"], () => [l(ve, {
      clsPrefix: r
    }, {
      default: () => l(gn, null)
    })]) : oe(c["password-invisible-icon"], () => [l(ve, {
      clsPrefix: r
    }, {
      default: () => l(mn, null)
    })])) : null]) : null)), this.pair ? l("span", {
      class: `${r}-input__separator`
    }, oe(c.separator, () => [this.separator])) : null, this.pair ? l("div", {
      class: `${r}-input-wrapper`
    }, l("div", {
      class: `${r}-input__input`
    }, l("input", {
      ref: "inputEl2Ref",
      type: this.type,
      class: `${r}-input__input-el`,
      tabindex: this.passivelyActivated && !this.activated ? -1 : void 0,
      placeholder: this.mergedPlaceholder[1],
      disabled: this.mergedDisabled,
      maxlength: v ? void 0 : this.maxlength,
      minlength: v ? void 0 : this.minlength,
      value: Array.isArray(this.mergedValue) ? this.mergedValue[1] : void 0,
      readonly: this.readonly,
      style: this.textDecorationStyle[1],
      onBlur: this.handleInputBlur,
      onFocus: (i) => {
        this.handleInputFocus(i, 1);
      },
      onInput: (i) => {
        this.handleInput(i, 1);
      },
      onChange: (i) => {
        this.handleChange(i, 1);
      }
    }), this.showPlaceholder2 ? l("div", {
      class: `${r}-input__placeholder`
    }, l("span", null, this.mergedPlaceholder[1])) : null), j(c.suffix, (i) => (this.clearable || i) && l("div", {
      class: `${r}-input__suffix`
    }, [this.clearable && l(he, {
      clsPrefix: r,
      show: this.showClearButton,
      onClear: this.handleClear
    }, {
      icon: () => {
        var a;
        return (a = c["clear-icon"]) === null || a === void 0 ? void 0 : a.call(c);
      },
      placeholder: () => {
        var a;
        return (a = c["clear-icon-placeholder"]) === null || a === void 0 ? void 0 : a.call(c);
      }
    }), i]))) : null, this.mergedBordered ? l("div", {
      class: `${r}-input__border`
    }) : null, this.mergedBordered ? l("div", {
      class: `${r}-input__state-border`
    }) : null, this.showCount && b === "textarea" ? l(ue, null, {
      default: (i) => {
        var a;
        const {
          renderCount: h
        } = this;
        return h ? h(i) : (a = c.count) === null || a === void 0 ? void 0 : a.call(c, i);
      }
    }) : null);
  }
});
export {
  eo as default,
  Sn as inputProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/input/src/Input.js
// module id = 33
// module chunks = 67